import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ReviewSetSdk } from '@sdks/review-set.sdk';
import { selectSteps } from '@store/global/global.selectors';
import { BehaviorSubject, filter, map, Observable, takeUntil, withLatestFrom } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-split-review-set',
    templateUrl: './split-review-set.component.html',
    styleUrl: './split-review-set.component.scss',
    standalone: false
})
export class SplitReviewSetComponent extends BaseComponent implements OnInit {

  public selectedNumber: number = null;
  public numbers: number[];
  public reviewSet$: Observable<{
    id: string,
    name: string
  }>;
  public splitWorkflow: {
    workflowName: string
    workflowKey: string
    executionState: "New" | "Created" | "Started" | "Active" | "OnHold" | "Complete" | "Error" | "Aborted";
  } = null;

  private reviewSetSubject = new BehaviorSubject<{
    id: string,
    name: string
  }>(null);
  private reviewSet: {
    id: string,
    name: string
  };

  constructor(
    private store: Store,
    private reviewSetSdk: ReviewSetSdk,
    private dialogRef: MatDialogRef<SplitReviewSetComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    super();
    this.reviewSetSubject.next({
      id: this.dialogData?.id,
      name: this.dialogData?.name
    });
    this.reviewSet$ = this.reviewSetSubject.asObservable();

    this.store.select(selectSteps).pipe(
      map((w) => w?.filter(w => w?.workflowName === 'SplitReviewSetWorkflow')),
      withLatestFrom(this.reviewSet$),
      filter(([, reviewSet]) => !!reviewSet),
      takeUntil(this.destroy$)
    ).subscribe(([workflows, reviewSet]) => {
      this.reviewSet = reviewSet;
      const currentWorkflowState = workflows?.find(w => w.workflowKey.split('#')[0].toLocaleLowerCase() === this.reviewSet.id);
      if (currentWorkflowState) {
        this.splitWorkflow = {
          workflowKey: currentWorkflowState.workflowKey,
          workflowName: currentWorkflowState.workflowName,
          executionState: currentWorkflowState.workflowExecutionState
        };
      }
      else
        this.splitWorkflow = null;
    });

  }

  public ngOnInit(): void {
    this.numbers = Array.from({ length: 9 }, (_, i) => i + 2);
  }

  public startSplitReviewSet(): void {
    this.reviewSetSdk.splitReviewSet({
      reviewSetId: this.reviewSet.id,
      numOfBatches: this.selectedNumber
    }).subscribe(() => {
      this.close();
    });
  }

  public close(): void {
    const splitJobStarted: boolean = (this.splitWorkflow?.executionState === 'New') ||
      (this.splitWorkflow?.executionState === 'Started') ||
      (this.splitWorkflow?.executionState === 'Active');
    this.dialogRef.close({ splitJobStarted });
  }
}
